export default {
    getJwt(){
        var base64Url = localStorage.getItem('token').split('.')[1];
        var base64 = base64Url.replace('-', '+').replace('_', '/');
        
        return JSON.parse(window.atob(base64));      
    },
    getRole(){
        var base64Url = localStorage.getItem('token').split('.')[1];
        var base64 = base64Url.replace('-', '+').replace('_', '/');
        
        var jwt = JSON.parse(window.atob(base64));
        return jwt.roles; // We assume only 1 role.
    },
    getUserId(){
        var base64Url = localStorage.getItem('token').split('.')[1];
        var base64 = base64Url.replace('-', '+').replace('_', '/');
        
        var jwt = JSON.parse(window.atob(base64));
        return jwt.sub; // We assume only 1 role.
    },
    getEmail(){
        var base64Url = localStorage.getItem('token').split('.')[1];
        var base64 = base64Url.replace('-', '+').replace('_', '/');
        
        var jwt = JSON.parse(window.atob(base64));
        return jwt.email; // We assume only 1 role.
    },
    getName(){
        return this.getJwt().name;
    }
}


// WEBPACK FOOTER //
// ./WebApp/utils/jwt.js